var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8852 19.5209C47.9016 19.9428 47.907 20.3645 47.907 20.7864C47.907 33.5776 38.909 48.3443 22.4548 48.3443C17.4004 48.3443 12.7005 46.7334 8.7406 43.991C9.44059 44.0677 10.1515 44.1254 10.8733 44.1254C15.0641 44.1254 18.924 42.5717 21.9858 39.9636C18.0713 39.9061 14.7659 37.0871 13.626 33.2516C14.1732 33.3667 14.7368 33.4244 15.3132 33.4244C16.1259 33.4244 16.9149 33.3094 17.6713 33.0793C13.575 32.1972 10.4897 28.2851 10.4897 23.5867C10.4897 23.5292 10.4897 23.5099 10.4897 23.4715C11.6969 24.1811 13.0787 24.6219 14.5459 24.6795C12.1423 22.9343 10.5623 19.9619 10.5623 16.6059C10.5623 14.8416 11.0023 13.1731 11.7769 11.7349C16.1877 17.6031 22.7821 21.4577 30.2165 21.8605C30.0638 21.1509 29.9856 20.4032 29.9856 19.6553C29.9856 14.3048 33.9909 9.9707 38.9326 9.9707C41.5053 9.9707 43.8289 11.1407 45.4598 13.02C47.5015 12.5981 49.4143 11.7928 51.1451 10.6805C50.4742 12.9434 49.0579 14.8415 47.207 16.0305C49.0179 15.8004 50.7452 15.283 52.3469 14.5159C51.1451 16.4528 49.6324 18.1593 47.8852 19.5209Z",
    fill: "#1EA1F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.7b195e0dc892f248723378d77bddf971.svg";
export { ForwardRef as ReactComponent };